export default __webpack_public_path__ + "static/media/image-plus.91a77922.webp";